import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "WirelessCheckout"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M13.4996 21V19.5C15.4887 19.5 17.3964 18.7098 18.8029 17.3033C20.2094 15.8968 20.9996 13.9891 20.9996 12H22.4996C22.4996 16.9706 18.4702 21 13.4996 21ZM13.4996 17.25V15.75C14.4942 15.75 15.448 15.3549 16.1513 14.6517C16.8545 13.9484 17.2496 12.9946 17.2496 12H18.7496C18.7496 14.8995 16.3991 17.25 13.4996 17.25ZM15.7497 8.25H20.2497V9.75H3.12721L4.39471 18H11.2497V19.5H4.40971C3.66174 19.5085 3.02186 18.9646 2.90971 18.225L1.49971 9.1125C1.46669 8.89495 1.53087 8.67387 1.67526 8.50782C1.81965 8.34177 2.02968 8.24751 2.24971 8.25H6.74971V5.25C6.74971 4.00736 7.75707 3 8.99971 3H13.4997C14.7424 3 15.7497 4.00736 15.7497 5.25V8.25ZM8.99961 4.5C8.5854 4.5 8.24961 4.83579 8.24961 5.25V8.25H14.2496V5.25C14.2496 4.83579 13.9138 4.5 13.4996 4.5H8.99961Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/WirelessCheckout.vue"]]);
